import React, { useEffect } from "react";
import { Route, Switch } from "react-router";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { isWebView } from "go-core/utils/utils";
import SupportAccessNavigation from "./components/SupportAccessNavigation";
import OrganizationSupportAccessPage from "./pages/SupportAccess";

const OrganizationServiceAccessPage = (props: RouteComponentProps) => {
	const { update } = useIntercom();

	useEffect(() => {
		update({ hideDefaultLauncher: true });
	}, []);

	return (
		<div className={isWebView ? "support-webview-page" : "page-container"}>
			{!isWebView && <SupportAccessNavigation />}
			<Switch>
				<Route path={`${props.match.url}/support_access`} component={OrganizationSupportAccessPage} />
				<Redirect from={`${props.match.url}`} exact to={`${props.match.url}/support_access`} />
			</Switch>
		</div>
	);
};

export default OrganizationServiceAccessPage;
